
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"53","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.01 25.982A25 25 0 1126.028 1 24.981 24.981 0 0151.01 25.982z","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M37.13 25.982c0 13.799-4.97 24.982-11.102 24.982-6.132 0-11.128-11.183-11.128-24.982 0-12.073 3.806-22.148 8.866-24.473A5.214 5.214 0 0126.001 1c6.16 0 11.128 11.183 11.128 24.982zM2.237 26.381H50.61M4.617 14.481H47.44M4.617 38.273H46.65","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    